import { render, staticRenderFns } from "./CategoryDropdown.vue?vue&type=template&id=3cbd7784&scoped=true"
import script from "./CategoryDropdown.vue?vue&type=script&lang=js"
export * from "./CategoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./CategoryDropdown.vue?vue&type=style&index=0&id=3cbd7784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbd7784",
  null
  
)

export default component.exports